import React from "react";
import { Paper, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import SendIcon from "@material-ui/icons/Send";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import TimerIcon from "@material-ui/icons/Timer";
import ChatIcon from "@material-ui/icons/Chat";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import PieChartOutlinedIcon from "@material-ui/icons/PieChartOutlined";

const useStyles = makeStyles((theme) => ({
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(168px, 1fr))",
    gap: theme.spacing(1.5)
  },
  metricCard: {
    padding: theme.spacing(1.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    height: "100%",
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  metricContent: {
    flex: 1
  },
  metricLabel: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5)
  },
  metricValue: {
    fontSize: "1.45rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.15
  },
  metricIcon: {
    fontSize: "1.8rem",
    opacity: 0.9
  },
  iconSuccess: {
    color: "#4caf50"
  },
  iconError: {
    color: "#f44336"
  },
  iconInfo: {
    color: "#2196f3"
  },
  iconWarning: {
    color: "#ff9800"
  },
  iconPrimary: {
    color: theme.palette.primary.main
  }
}));

const MetricsCards = ({ metrics, reportType = "contacts" }) => {
  const classes = useStyles();

  if (!metrics) {
    return null;
  }

  const sharedMetricItems = [
    {
      label: "Total Enviados",
      value: metrics.totalSent || 0,
      icon: <SendIcon className={`${classes.metricIcon} ${classes.iconInfo}`} />
    },
    {
      label: "Total Entregados",
      value: metrics.totalDelivered || 0,
      icon: <CheckCircleIcon className={`${classes.metricIcon} ${classes.iconSuccess}`} />
    },
    {
      label: "Total Fallidos",
      value: metrics.totalFailed || 0,
      icon: <CancelIcon className={`${classes.metricIcon} ${classes.iconError}`} />
    },
    {
      label: "Tasa de Éxito",
      value: `${metrics.successRate || 0}%`,
      icon: <TrendingUpIcon className={`${classes.metricIcon} ${classes.iconWarning}`} />
    },
    {
      label: "Tiempo Promedio de Entrega",
      value: `${metrics.avgDeliveryTime || 0} min`,
      icon: <TimerIcon className={`${classes.metricIcon} ${classes.iconPrimary}`} />
    }
  ];

  const groupMetricItems = [
    ...sharedMetricItems,
    {
      label: "Pendientes",
      value: metrics.totalPending || 0,
      icon: <PieChartOutlinedIcon className={`${classes.metricIcon} ${classes.iconPrimary}`} />
    }
  ];

  const contactMetricItems = [
    ...sharedMetricItems,
    {
      label: "Respondieron contacto",
      value: metrics.totalContactReplied || 0,
      icon: <ChatIcon className={`${classes.metricIcon} ${classes.iconPrimary}`} />
    },
    {
      label: "% respuesta (sobre entregados)",
      value: `${metrics.replyRateOfDeliveredPct ?? 0}%`,
      icon: (
        <PieChartOutlinedIcon
          className={`${classes.metricIcon} ${classes.iconPrimary}`}
        />
      )
    },
    {
      label: "IA contestó tras respuesta",
      value: metrics.totalAiRepliedAfterContact || 0,
      icon: <FlashOnIcon className={`${classes.metricIcon} ${classes.iconWarning}`} />
    },
    {
      label: "% IA / entregados",
      value: `${metrics.aiReplyRateOfDeliveredPct ?? 0}%`,
      icon: <TrendingUpIcon className={`${classes.metricIcon} ${classes.iconInfo}`} />
    }
  ];
  const metricItems = reportType === "groups" ? groupMetricItems : contactMetricItems;

  return (
    <Box mb={2}>
      <Typography variant="h6" style={{ fontWeight: 700, marginBottom: 12 }}>
        Resumen
      </Typography>
      <Box className={classes.grid}>
        {metricItems.map((item) => (
          <Paper key={item.label} className={classes.metricCard} variant="outlined" elevation={0}>
            <Box className={classes.metricContent} minWidth={0}>
              <Typography className={classes.metricLabel}>
                {item.label}
              </Typography>
              <Typography className={classes.metricValue}>
                {item.value}
              </Typography>
            </Box>
            <Box>{item.icon}</Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default MetricsCards;
